/**
 * This file is part of VILLASweb.
 *
 * VILLASweb is free software: you can redistribute it and/or modify
 * it under the terms of the GNU General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * VILLASweb is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with VILLASweb. If not, see <http://www.gnu.org/licenses/>.
 ******************************************************************************/

const villasweb_values = {
  title: 'OPAL-RT VILLASweb',
  //  subtitle: 'OPAL-RT Web Dashboards',
  logo: 'logo_opalrt_square.svg',
  pages: {
    home: true,
    scenarios: true,
    infrastructure: true,
    account: true,
    api: true,
  },
  style: {
    background: '#f0f4f7',
    backgroundText: '#000000',
    highlights: '#1158a2',
    main: '#092f56',
    secondaryText: '#c4c4c4',
    fontFamily: 'Open Sans',
    // borderRadius: ''
  }
}

export default villasweb_values;
